module.exports = __webpack_public_path__ + "bf5ff28b051ec1a02443e09deb92deb5.MP3";